import React from 'react';
import { isBrandActive } from '../../utils/vendorBranding';

const VendorBrandBanner = ({ brand, businessName, logoUrl }) => {
  if (!isBrandActive(brand) || brand.hero_style !== 'banner') {
    return null;
  }

  const displayLogo = brand.show_logo_in_header !== false && logoUrl;

  return (
    <div className="relative mb-4 sm:mb-6 -mx-3 sm:mx-0 rounded-none sm:rounded-xl overflow-hidden">
      <div className="relative h-40 sm:h-52 md:h-60">
        {brand.cover_image_url ? (
          <img
            src={brand.cover_image_url}
            alt=""
            className="w-full h-full object-cover"
          />
        ) : (
          <div
            className="w-full h-full"
            style={{
              background: `linear-gradient(135deg, ${brand.primary_color}, ${brand.accent_color})`,
            }}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
        <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 flex items-center gap-3 max-w-[85%]">
          {displayLogo && (
            <img
              src={logoUrl}
              alt=""
              className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-white shadow-md flex-shrink-0"
            />
          )}
          <div className="min-w-0">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-light text-white truncate">
              {businessName}
            </h2>
            {brand.tagline && (
              <p className="text-sm sm:text-base text-white/90 font-light mt-0.5 line-clamp-2">
                {brand.tagline}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorBrandBanner;
